export const SIDEPANEL_WIDTH = '270px'

export const resourceIsCurrent = (resource) => ( 
  resource.status != 'pending_completing' &&
  resource.status != 'overdue' &&
  resource.status != 'upcoming'
)